<template>
  <Modal v-model="viewTaxRatesModal" :title="$t('key1005473')" width="650"
    :transfer="false" :mask-closable="true" @on-visible-change="viewTaxRatesChange">
    <!--列表区域-->
    <div class="table-box">
      <Table
        highlight-row
        border
        max-height="600"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <template #footer>
      <Button type="primary" @click="viewTaxRatesModal = false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getAllCountrysData, getIossTaxRateData} from "@/utils/common";

export default {
  name: "viewTaxRatesModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      viewTaxRatesModal: false,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002474'),
          key: 'countryCode',
          align: 'center',
          render(h, params) {
            let twoCode = params.row.countryCode || null;
            let text = '';
            if (v.countrysOriginalData.length > 0) {
              v.countrysOriginalData.map((item) => {
                if (item.twoCode === twoCode) {
                  text = item.cnName;
                }
              });
              return h('span', text);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005477'),
          key: 'rate',
          align: 'center',
          render(h, params) {
            let rate = params.row.rate || 0;
            let text = (rate * 100).toFixed(2) + '%';
            return h('span', text);
          }
        }
      ],
      tableData: [],
      countrysOriginalData: []
    };
  },
  methods: {
    // 初始化数据
    initViewTaxRatesData() {
      let v = this;
      (async () => {
        await getAllCountrysData().then((data) => {
          this.countrysOriginalData = data;
        });
        await v.getList();
      })();
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.tableLoading = true;
      getIossTaxRateData('distributor').then((data) => {
        v.tableLoading = false;
        v.tableData = data;
        v.viewTaxRatesModal = true;
      });
    },
    // 监听弹窗
    viewTaxRatesChange(val) {
      if (!val) {
        this.tableData = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>